import { HttpErrorResponse } from '@angular/common/http';
import { IFaehigkeit } from '../../shared/model/faehigkeit.model';

export const SKILL_SORT_LOCALE = 'de';

export function compareText(
  a: string | null | undefined,
  b: string | null | undefined,
): number {
  return (a ?? '').localeCompare(b ?? '', SKILL_SORT_LOCALE, {
    sensitivity: 'base',
  });
}

export function sameText(
  a: string | null | undefined,
  b: string | null | undefined,
): boolean {
  return (a ?? '').trim().toLowerCase() === (b ?? '').trim().toLowerCase();
}

export function hasText(value: string | null | undefined): boolean {
  return !!value && value.trim().length > 0;
}

export function sortSkills(skills: IFaehigkeit[]): IFaehigkeit[] {
  return [...skills].sort(
    (a, b) =>
      compareText(a.faehigkeit, b.faehigkeit) ||
      compareText(a.kategorie, b.kategorie),
  );
}

/** Last segment of the problem type URI, e.g. `entity-name-already-exists`. */
export function problemType(error: unknown): string {
  const type =
    error instanceof HttpErrorResponse ? error.error?.type : undefined;
  return typeof type === 'string'
    ? type.substring(type.lastIndexOf('/') + 1)
    : '';
}

export interface TextPart {
  text: string;
  match: boolean;
}

export function highlightParts(text: string, query: string): TextPart[] {
  const needle = query.trim().toLowerCase();
  const index = needle ? text.toLowerCase().indexOf(needle) : -1;
  if (index < 0) {
    return [{ text, match: false }];
  }
  return [
    { text: text.slice(0, index), match: false },
    { text: text.slice(index, index + needle.length), match: true },
    { text: text.slice(index + needle.length), match: false },
  ].filter((part) => part.text.length > 0);
}
